import { request } from "./http";

function unwrapItem(raw) {
  if (raw && typeof raw === "object" && raw.item && typeof raw.item === "object") {
    return raw.item;
  }
  return raw && typeof raw === "object" ? raw : {};
}

export const psychologistAccessApi = {
  async getMyRequest() {
    const response = await request("/api/me/psychologist-verification");
    return unwrapItem(response);
  },

  async submitRequest(note = "") {
    const response = await request("/api/me/psychologist-verification/request", {
      method: "POST",
      json: { note: String(note || "").trim() },
    });
    return unwrapItem(response);
  },
};
